/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

const breakpoint = 1600;

export const ChangeContainer = styled.div`
  display: flex;
  gap: 4px;
  color: ${({ change }) =>
    change > 0
      ? `${Palette.Teal._600}`
      : !change
      ? `${Palette.PrimaryGray._400}`
      : `${Palette.Red._600}`};
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 16px;
  user-select: none;
  height: 18px;
  align-items: center;

  @media (min-width: ${breakpoint}px) {
    justify-content: flex-end;
  }
`;

export const PrevLoaderWrap = styled.div`
  width: auto;

  & span {
    width: 16px !important;
    height: 16px !important;
    margin-top: 8px;
  }
`;

export const LabelWrap = styled.div`
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const DataWrap = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${breakpoint - 1}px) {
    flex-direction: column;
  }
`;

export const RightContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;

  @media (min-width: ${breakpoint}px) {
    text-align: right;
    align-self: flex-end;
    max-width: 72px;
    margin-top: unset;
    margin-bottom: unset;
  }
`;

export const LabelText = styled.div`
  color: ${({ isSelected, isChartHidden }) =>
    !isSelected && !isChartHidden ? `${Palette.PrimaryGray._500}` : `${Palette.PrimaryGray._700}`};
  font-weight: 500;
  font-size: 16px;
  font-family: 'Roboto';
  user-select: none;
`;

export const Value = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-weight: 700;
  font-size: 32px;
  font-family: 'Roboto';
  user-select: none;

  @media (max-width: ${breakpoint - 1}px) {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
  }
`;

export const SmallText = styled.div`
  color: ${Palette.PrimaryGray._400};
  font-weight: 400;
  font-size: 12px;
  font-family: 'Roboto';
  user-select: none;
  white-space: pre;
`;

export const Avg = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-weight: 500;
  font-size: 14px;
  font-family: 'Roboto';
  text-overflow: ellipsis;
  overflow: hidden;
  text-wrap: nowrap;
  margin-top: auto;
  min-height: 17px;
  user-select: none;
`;

export const TopLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ isChartHidden, isSelected, color }) =>
    !isSelected && !isChartHidden ? 'transparent' : color.main};
  transfrom: translateY(-1px);
`;

export const AnimatedIconButton = styled.div`
  width: 16px;
  height: 8px;
  cursor: pointer;
  border: 2px solid ${({ color }) => color.main};
  border-radius: 4px;
`;

export const Icon = styled.svg`
  width: 16px;
  height: 8px;
  fill: none;
  stroke-width: 2;
`;

export const Container = styled.div`
  position: relative;
  background-color: ${({ isSelected, isChartHidden }) =>
    isSelected || isChartHidden ? 'white' : 'transparent'};
  border-bottom: ${({ isSelected, isChartHidden }) =>
    isSelected || isChartHidden ? '1px solid white' : '1px solid rgba(226, 232, 240, 1)'};
  border-right: 1px solid rgba(226, 232, 240, 1);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 24px;
  cursor: pointer;
`;

export const OuterContainer = styled.div`
  flex-grow: 1;
  flex-basis: calc(100% / 6);
  pointer-events: ${({ isChartHidden }) => (isChartHidden ? 'none' : 'auto')};

  &:last-child > div {
    border-right: unset;
  }
`;
